module.exports = (function() {
	$(".search-more").bind("click", function(){
		ShowOptions(this, this.dataset.showOptions == "true");
	}).find("[name='hide']").hide();

	$(".reset-options").bind("click", function() { // Reseting options logic
		var $options = $(this).siblings(".search-options");
		var $more = $(this).siblings(".search-more");
		$options.find("input[type='radio'].default-option").prop('checked', true).change();
		$options.find("input[type='radio'].specific-value").val("");
		$options.find("a[data-empty-label]").each(function() { this.innerHTML = this.dataset.emptyLabel; });
		ShowOptions($more, false);
	});

	$(".search-options").each(function(i,elem) {
		$(".search-feature input", elem).attr("id", function(j, attr) {
			$(this).siblings("label[for='"+attr+"']").attr("for", attr + i);
			return attr + i;
		});
	});
	
	$(".search-feature input[type='radio']").bind("change", function() {
		// Is there at least one option selected?
		var bShowReset = false;
		var $localOptions = $(this).closest(".search-options");
		$localOptions.find(".search-feature input[type='radio']:checked").each(function() {
			if(!$(this).hasClass("default-option")) {
				bShowReset = true;
				return;
			}
		});
		$localOptions.siblings(".reset-options").toggle(bShowReset);

	}).filter(".specific-value").bind("click", function() {
		if(this.value == "") { // If no value is chosen, pop the modal
			$("a[data-linked-radio='"+$(this).attr("name")+"']").click();
		}
	});

	$(".search-feature a[data-show-modal]").bind("click", function() { // Handle opening modals
		var $searchFeatures = $(this).closest(".search-feature");
		var $specificRadio = $searchFeatures.find(".specific-value");
		var optionParams = {};
		optionParams[$specificRadio.attr("name")] = $specificRadio.val();
		RefreshButtonStates(optionParams);

		$specificRadio.prop("checked", true).change();
		$('#'+this.dataset.showModal).foundation('open').data("reference", $searchFeatures);
	});

	$("#searchLangModal .items a").bind("click", function() { // Handle Language selection
		var $modal = $('#searchLangModal');
		UpdateOption($modal.data("reference"), this.dataset.value, this.innerHTML);
		$modal.foundation('close');
	});

	$("#searchSiteModal .items a").bind("click", function() { // Handle site selection
		$(this).toggleClass("fill");
	});

	$(document).on('closed.zf.reveal', '#searchSiteModal[data-reveal]', function () { // Handle site selection confirmation
		var categories = $(this).find('.items a.fill').map(function(){ return this.dataset.value; }).get().join(',');
		UpdateOption($(this).data("reference"), categories, GetSitesSelected(categories));
	});
})();

function ShowOptions(toggler, bShow) {
	$(toggler).attr("data-show-options", !bShow);
	$(toggler).find("[name='more']").toggle(!bShow);
	$(toggler).find("[name='hide']").toggle(bShow);
	$(toggler).siblings(".search-options").toggle(bShow);
}

function RefreshButtonStates(params) {
	// Language
	$("#searchLangModal .items a").removeClass("fill").filter("[data-value='"+params.lang+"']").addClass("fill");

	//Sites
	var $sitesModal = $("#searchSiteModal .items a");
	$sitesModal.removeClass("fill");
	var siteSelector = ListToArrayClean(params.categories).map(function(site) { return "[data-value='"+site+"']"; });
	$sitesModal.filter(siteSelector.join(",")).addClass("fill");
}

function UpdateOption($optSel, value, label) {
	$optSel.find("input[type='radio'].specific-value").val(value);
	$optSel.find("a[data-show-modal]").each(function() {
		this.innerHTML = label.length ? label : this.dataset.emptyLabel;
	});
}

function LangFromLangCode(langCode) {
	return $("#searchLangModal .items a[data-value='"+langCode+"']").text();
}

function GetSitesSelected(categories) {
	return ListToArrayClean(categories).map(function(element){
		return '<nobr>'+ $("#searchSiteModal .items a[data-value='"+element+"']").text() + '</nobr>';
	}).join(', ');
}

function ListToArrayClean(list) {
	if (!list) list = "";
	var arr = list.indexOf(',') != -1 ? list.split(',') : [list];
	return arr.filter(Boolean);
}

function GetURLParams(qryString) {
	return qryString.substr(1).split('&').reduce(function (q, query) {
		var chunks = query.split('=');
		var key = chunks[0];
		var value = chunks[1];
		return (q[key] = value, q);
	}, {});
}

function ReloadSearch(qryString) {
	var params = GetURLParams(qryString);
	var decodedParams = jQuery.extend({}, params);
	Object.keys(decodedParams).forEach(function(key) { decodedParams[key] = decodeURIComponent(decodedParams[key]); });
	decodedParams.term = decodedParams.term.replace(/\+/g, " ");
	var pageNum = parseInt(params.Page == null ? 1 : params.Page);
	var categoryFilter = params.categories == "" ? "" : params.categories+",1xnews";

	jQuery("#addSearchResults").addClass("ajax-load");
	document.title = decodedParams.term + " - " + $.i18n._(8353) + " " + pageNum;

	// Temporary fix*** .replace(/\%7E/g,"") Remove when AddSearch allows %7E in their term
	LoadApiData("https://api.addsearch.com/v1/search/3685af67a4208529489ba96ae59befde",
		"term="+params.term.replace(/\%7E/g, "")+"&page="+pageNum+"&categories="+categoryFilter+"&lang="+params.lang,
		{ onSuccess: function (data) {
			data.totalHitsTrans = $.i18n._(16673);
			data.categoryTrans = $.i18n._(16695);
			data.langTrans = $.i18n._(6875);
			data.term = decodedParams.term;
			data.categoriesDsp = GetSitesSelected(decodedParams.categories);
			data.langDsp = LangFromLangCode(params.lang);
			// Refresh the page list
			$("#searchPageNumber").html(GenPageList(pageNum, data.total_hits, 10,10,3,
				location.origin + location.pathname + "?term="+params.term.replace(/\%7E/g, "")+"&categories="+params.categories+"&lang="+params.lang, "#searchPageAnchor", true));
			// Add a click event for each page button that has a href
			$("#searchPageNumber a[href!='']").click(function(){ RefreshSearchFromURL(this.href); });

			LoadUnderscoreTemplate(window.lcb.config.templatePaths.searchResults, data, {
				onSuccess: function(html){
					LoadTemplateDiv('#addSearchResults', html, {pagination: false});
					jQuery("#addSearchResults").removeClass("ajax-load");
				}
			});
		}
	});
}

window.RefreshSearchFromURL = function(url) {
	ReloadSearch(window.location.search);
}

window.SetSearchOptions = function() {
	var params = GetURLParams(location.search);

	Object.keys(params).forEach(function(key) { params[key] = decodeURIComponent(params[key]); }); // decode all values
	$("#resultPageSearch form.search-form input[name='term']").val(params.term.replace(/\+/g, " "));

	if (params.lang) {
		var $allLanguages = $(".search-option-lang");
		UpdateOption($allLanguages, params.lang, LangFromLangCode(params.lang));
		$allLanguages.find("input[type='radio'][value='"+params.lang+"']").prop('checked', true).change();
	}
	if (params.categories) {
		var $allCatgories = $(".search-option-category");
		UpdateOption($allCatgories, params.categories, GetSitesSelected(params.categories));
		$allCatgories.find("input[type='radio'][value='"+params.categories+"']").prop('checked', true).change();
	}
}